import {
  exampleListService,
  masterDataCountryListShortService,
  masterDataProvinceListShortService,
  masterDataDistrictListShortService,
  masterDataWardListShortService,
  leavePolicyListService,
  workLevelListShortService,
  departmentListShortService,
  branchListShortService,
  titleListShortService,
  contractTypeListShortService,
  employeeListShortService,
  masterDataTimezoneListShortService,
  masterDataBankListShortService,
  approvalWorkflowListShortService,
  templateListByUserService,
  masterDataEthnicityListService,
  deductionListShortService,
  allowanceListShortService,
  earningListShortService,
  compensationListShortService,
  templateListShortService,
  roleListShortService,
  workShiftListShortService,
  leaveTypeListShortService,
  benefitsInKindListShortService,
  payrollCycleListShortService,
  paMachineListShortService,
  paMachineGroupListShortService,
  paProductListShortService,
  paReasonStopListShortService,
  paTemplateListShortService,
  paTemplateListByUserService,
  workShiftListPAShortService,
} from "services";
import { checkMainLan } from "utils";

import { ModelName } from "./types";

export const getServices = (
  model: ModelName,
  keyword?: string,
  depField?: number | string | (string | number)[],
  page?: number
) => {
  const paginationConfig = {
    page,
    limit: 50,
    status: 1,
  };

  switch (model) {
    case "country":
      return masterDataCountryListShortService({
        ...paginationConfig,
        ...(!checkMainLan() ? { name: keyword } : { nativeName: keyword }),
      });

    case "province":
      return masterDataProvinceListShortService({
        ...paginationConfig,
        ...(!checkMainLan() ? { name: keyword } : { nativeName: keyword }),
        countryId: depField as number,
      });

    case "district":
      return masterDataDistrictListShortService({
        ...paginationConfig,
        ...(!checkMainLan() ? { name: keyword } : { nativeName: keyword }),
        provinceId: depField as number,
      });

    case "ward":
      return masterDataWardListShortService({
        ...paginationConfig,
        ...(!checkMainLan() ? { name: keyword } : { nativeName: keyword }),
        districtId: depField as number,
      });

    case "deduction":
      return deductionListShortService({
        ...paginationConfig,
        keyword,
      }) as unknown;

    case "allowance":
      return allowanceListShortService({
        ...paginationConfig,
        keyword,
      }) as unknown;

    case "earning":
      return earningListShortService({
        ...paginationConfig,
        keyword,
      }) as unknown;

    case "compensation":
      return compensationListShortService({
        ...paginationConfig,
        keyword,
      }) as unknown;

    case "leavePolicy":
      return leavePolicyListService({
        ...paginationConfig,
        keyword,
      }) as unknown;

    case "workLevel":
      return workLevelListShortService({
        ...paginationConfig,
        keyword,
      }) as unknown;

    case "department":
      return departmentListShortService({
        ...paginationConfig,
        name: keyword,
      });

    case "branch":
      return branchListShortService({
        ...paginationConfig,
        name: keyword,
      });

    case "title":
      return titleListShortService({
        ...paginationConfig,
        name: keyword,
      });

    case "contractType":
      return contractTypeListShortService({
        ...paginationConfig,
        name: keyword,
      });

    case "employee":
      return employeeListShortService({
        ...paginationConfig,
        keyword,
      });

    case "payroll-template":
      return templateListShortService({
        ...paginationConfig,
        name: keyword,
        pics: (depField as string[]) || undefined,
      });

    case "payroll-template-pic":
      return templateListByUserService({
        ...paginationConfig,
        name: keyword,
      });

    case "timezone":
      return masterDataTimezoneListShortService({
        ...paginationConfig,
        name: keyword,
      });

    case "workShift":
      return workShiftListShortService({
        ...paginationConfig,
        keyword,
      });

    case "leaveType":
      return leaveTypeListShortService({
        ...paginationConfig,
        keyword,
      });

    case "bank":
      return masterDataBankListShortService({
        ...paginationConfig,
        countryId: depField as number,
        name: keyword,
      });

    case "approvalWorkflow":
      return approvalWorkflowListShortService({
        ...paginationConfig,
        flow: depField as string,
        keyword,
      });

    case "ethnicity":
      return masterDataEthnicityListService({
        ...paginationConfig,
        ...(!checkMainLan() ? { name: keyword } : { nativeName: keyword }),
        countryId: depField as number,
      });

    case "role":
      return roleListShortService({
        ...paginationConfig,
      });

    case "benefitsInKind":
      return benefitsInKindListShortService({
        ...paginationConfig,
        keyword,
      }) as unknown;

    case "machine":
      return paMachineListShortService({
        ...paginationConfig,
        ...(!checkMainLan() ? { name: keyword } : { nativeName: keyword }),
        groupMachineId: depField as string,
      });

    case "machine-group":
      return paMachineGroupListShortService({
        ...paginationConfig,
        ...(!checkMainLan() ? { name: keyword } : { nativeName: keyword }),
      });

    case "product":
      return paProductListShortService({
        ...paginationConfig,
        ...(!checkMainLan() ? { name: keyword } : { nativeName: keyword }),
      });

    case "reason-stop-machine":
      return paReasonStopListShortService({
        ...paginationConfig,
        ...(!checkMainLan() ? { name: keyword } : { nativeName: keyword }),
      });

    case "payrollCycle":
      return payrollCycleListShortService({
        ...paginationConfig,
        keyword,
      });

    case "productivity-template":
      return paTemplateListShortService({
        ...paginationConfig,
        keyword,
      });

    case "productivity-template-pic":
      return paTemplateListByUserService({
        ...paginationConfig,
        keyword,
      });

    case "productivity-workShift":
      return workShiftListPAShortService({
        ...paginationConfig,
        keyword,
      });

    default:
      return exampleListService({
        ...paginationConfig,
        keyword,
      });
  }
};
